module.exports = __webpack_public_path__ + "img/ic-header-billing.ecc1dbc4.svg";